// Activity User Types and Enums

export const ActivityUserRole = {
  ADMIN: 'admin',
  PROGRAM_MANAGER: 'program_manager',
  PROGRAM_OFFICER: 'program_officer',
  FIELD_OFFICER: 'field_officer'
}

export const UserRoleType = {
  service_provider: 'service_provider',
  processor: 'processor',
  miller: 'miller'
}

export const Permission = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  FULL_ACCESS: 'full_access'
}

// Activity permissions structure
export const ActivityPermissions = {
  activities: [Permission.READ, Permission.CREATE, Permission.UPDATE, Permission.DELETE],
  farmers: [Permission.READ, Permission.CREATE, Permission.UPDATE, Permission.DELETE],
  farms: [Permission.READ, Permission.CREATE, Permission.UPDATE, Permission.DELETE],
  commodities: [Permission.READ, Permission.CREATE, Permission.UPDATE, Permission.DELETE],
  user_creation: []
}

// Role capabilities for UI control
export const RoleCapabilities = {
  canCreateActivities: false,
  canRegisterUnregisterFarmers: false,
  canViewActivities: false,
  canAddFarmers: false,
  canDeleteFarmers: false,
  canCreateUsers: false,
  canCreateProgramOfficers: false,
  canCreateFieldOfficers: false,
  canMapFarms: false,
  canUploadPhotos: false,
  canAccessWeb: false,
  canAccessMobile: false,
  canManageProgram: false,
  canAddFarms: false
}

// User type structure
export const UserType = {
  id: null,
  email: '',
  full_name: '',
  user_type: '',
  is_activity_user: false,
  activity_role: null
}

// Activity role structure
export const ActivityRole = {
  role_name: '',
  display_name: '',
  description: '',
  can_create_users: false,
  permissions: ActivityPermissions
}
